var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex ml-auto bg-theme-2 px-4 py-1 rounded-full shadow-md",on:{"click":function($event){return _vm.$emit('click')}}},[_c('DownloadIcon',{staticClass:"h-4 report-box__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }